import { observer } from "mobx-react"

import { AgentInstances } from "src/components/AgentSelection"
import { LibraryInformationItemStore } from "src/modals/library-information-items/store"
import { useStore } from "src/store/lib/useStore"

export const LibraryInformationItemsAgentInstances = observer(() => {
    const store = useStore(LibraryInformationItemStore)

    return <AgentInstances store={store} />
})
